const TARGET_WIDTH = 1000;
const TARGET_HEIGHT = 1000;
const JPEG_QUALITY = 0.86;
const MAX_SIZE_KB = 250;

const loadImage = (src) =>
    new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
    });

const canvasToBlob = (canvas, quality) =>
    new Promise((resolve) => {
        canvas.toBlob((blob) => resolve(blob), 'image/jpeg', quality);
    });

const blobToDataUrl = (blob) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });

/**
 * Resize and compress a data-URL image before upload.
 * Caps dimensions at 1000×1000px and targets ~250 KB JPEG output.
 * Safe to call on already-small images — returns original if canvas fails.
 */
export const compressDataUrlForUpload = async (dataUrl) => {
    if (!dataUrl || typeof dataUrl !== 'string' || !dataUrl.startsWith('data:image')) {
        return dataUrl;
    }

    try {
        const img = await loadImage(dataUrl);
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        if (width > height) {
            if (width > TARGET_WIDTH) {
                height = Math.round(height * TARGET_WIDTH / width);
                width = TARGET_WIDTH;
            }
        } else if (height > TARGET_HEIGHT) {
            width = Math.round(width * TARGET_HEIGHT / height);
            height = TARGET_HEIGHT;
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) return dataUrl;

        ctx.drawImage(img, 0, 0, width, height);

        let blob = await canvasToBlob(canvas, JPEG_QUALITY);
        if (blob && blob.size > MAX_SIZE_KB * 1024) {
            blob = await canvasToBlob(canvas, JPEG_QUALITY * 0.75);
        }

        if (!blob) return dataUrl;

        return await blobToDataUrl(blob);
    } catch (e) {
        console.warn('imageCompress: compression failed, using original', e);
        return dataUrl;
    }
};
